import styled from 'styled-components';

const GeneralInformationFormStyle = styled.div`
  label {
    color: #fff;
  }

  .accountLoader {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 50px;
    color: #007afe;
  }

  /* ==================== MAIN CONTAINER ==================== */
  .GeneralInformationFormStyleclassName {
    margin-bottom: 0%;
  }

  .ho2 {
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 24px;
    letter-spacing: -0.01em;
  }

  /* ==================== TABS STYLING ==================== */
  .tabs {
    color: #6c6c6c;
    padding-bottom: 40px;
  }

  .ant-tabs-tab {
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px;
    font-weight: 500;
    padding: 14px 24px;
    color: #b8b8b8 !important;
    transition: all 0.2s ease;
    margin: 0 !important;
  }

  .ant-tabs-tab:hover {
    color: #ffffff !important;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #ffffff !important;
    font-weight: 600;
  }

  .ant-tabs-ink-bar {
    background: #007afe !important;
    height: 2px !important;
    border-radius: 2px 2px 0 0;
  }

  .ant-tabs-nav-wrap {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .ant-tabs-nav::before {
    border: none !important;
  }

  .ant-tabs-nav {
    padding: 0px 0px;
    margin-bottom: 24px !important;
  }

  .ant-tabs-tab-btn {
    font-family: 'Poppins', sans-serif !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
  }

  .ant-tabs-tabpane:not(.ant-tabs-tabpane-hidden) {
    display: flex;
    gap: 24px;
  }

  .ant-tabs-tabpane {
    width: 100%;
  }

  .ant-tabs-tabpane .row-space-profile {
    display: flex;
    gap: 24px;
    width: 100%;
  }

  /* ==================== PROFILE CARD (LEFT SIDE) ==================== */
  .profile {
    width: 300px;
    min-width: 350px;
    background: #111823;
    border-radius: 12px;
    padding-bottom: 32px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    position: relative;
    overflow: hidden;
  }

  .coverImageAccountinfo {
    height: 120px;
    width: 100%;
    object-fit: cover;
    border-radius: 12px 12px 0 0;
    filter: brightness(0.5);
  }

  .avatar {
    border: 3px solid #111823;
    margin-top: -36px;
    background: #007afe;
    box-shadow: 0 4px 16px rgba(0, 122, 254, 0.25);
  }

  .Profile-View-Span {
    width: 72px;
    height: 72px;
    line-height: 72px;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .row-profile-FormStyle {
    margin-left: 0%;
    padding: 0px 24px;
  }

  .po5 {
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    text-transform: none;
    padding: 16px 0px 8px;
    margin-top: 0%;
    margin-left: 0%;
  }

  .po5:first-letter {
    text-transform: none;
  }

  .divider1 {
    display: flex;
    justify-content: center;
    padding: 0px 0px 24px 0px;
  }

  .hr-90 {
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background: transparent;
    width: 85%;
    margin: 0;
  }

  .divide {
    width: 100%;
  }

  .po4 {
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 16px;
  }

  .po3 {
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    padding: 0px;
    margin-bottom: 16px;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pop1 {
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    padding: 0px;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    position: relative;
    align-items: center;
  }

  .spann {
    margin-left: 8px;
    color: #b8b8b8;
  }

  .fontsizespanpo4 {
    font-size: inherit;
    white-space: nowrap;
  }

  .po4 .spann.fontsizespanpo4,
  .pop1 .spanner.fontsizespanpo4 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: horizontal;
    overflow: hidden;
    width: calc(100% - 100px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #b8b8b8;
  }

  .divs2 {
    display: flex;
    justify-content: center;
    padding: 24px 0px 24px 0px;
  }

  .logoutButton {
    position: absolute;
    bottom: 24px;
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .btn1 {
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.05);
    padding: 12px 20px;
    width: 100%;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.25) !important;
    }
  }

  /* ==================== ACCOUNT DETAILS CARD (RIGHT SIDE) ==================== */
  .profile1 {
    flex: 1;
    background: #111823;
    border-radius: 12px;
    padding: 24px;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  .div-90 {
    width: 100%;
  }

  .h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    padding-bottom: 16px;
  }

  .rowing {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
  }

  .div {
    background: #181e27;
    border-radius: 10px;
    width: 130px;
    height: 110px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(0, 122, 254, 0.2);
      background: #1c232e;
    }
  }

  .svgDiv {
    background: #252d3a;
    width: 34px;
    height: 34px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 16px;
      height: 16px;
      filter: brightness(1.1);
    }
  }

  .ppo {
    font-family: 'Poppins', sans-serif;
    padding: 10px 0px 4px;
    font-size: 11px;
    color: #b8b8b8;
    text-align: center;
  }

  .p3 {
    font-family: 'Poppins', sans-serif;
    padding: 10px 0px;
    text-align: center;
    font-size: 11px;
    color: #b8b8b8;
  }

  .h5 {
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    color: #ffffff;
    font-weight: 600;
  }

  .divider3 {
    display: flex;
    justify-content: center;
    padding: 24px 0px;
  }

  .divider3 .hr-90 {
    width: 100%;
  }

  .diver23 {
    width: 100%;
  }

  .hoo2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    padding-bottom: 16px;
  }

  .rowing2 {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }

  .poo1 {
    font-family: 'Poppins', sans-serif;
    padding: 10px 0px;
    margin-left: 0px;
    font-size: 11px;
    color: #b8b8b8;
  }

  /* ==================== LINKED PROFILES TAB ==================== */
  .profile2 {
    width: 100%;
    background: #111823;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    padding: 24px;
  }

  .profile2 .diver2 {
    width: 100%;
  }

  .htp2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff !important;
    margin-bottom: 20px;
  }

  .rowing1 {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .profile2 .accountDetailBox {
    margin: 0px;
    position: relative;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    width: calc(50% - 6px);
    height: 88px;
    max-width: unset;
    background: #181e27;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(0, 122, 254, 0.2);
      background: #1c232e;
    }
  }

  .accountDetailBoxDisabledLayer {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(3px);
    border-radius: 10px;
    color: white;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 500;
    background-color: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(0, 122, 254, 0.25);
    }
  }

  .accountDetailBox .nameImage {
    display: flex;
    align-items: center;
  }

  .accountDetailBox .nameImage .diver4 {
    margin-right: 16px;
  }

  .diver4 {
    display: flex;
    justify-content: right;
    align-items: center;
  }

  .avater1 {
    background: #007afe;
  }

  .account-span {
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ppp1 {
    font-family: 'Poppins', sans-serif;
    padding: 4px 0px;
    margin-left: 0px;
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }

  .playListNumbers {
    font-family: 'Poppins', sans-serif !important;
    font-size: 12px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.02em;
    display: flex;
    align-items: center;
    color: #b8b8b8;
  }

  .playListNumbers svg {
    margin-right: 8px;
    width: 14px;
  }

  .btnns {
    background: rgba(234, 67, 53, 0.12);
    border: 1px solid rgba(234, 67, 53, 0.4);
    cursor: pointer;
    height: 38px;
    width: 38px;
    color: #ea4335;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    img {
      width: 16px;
    }

    &:hover {
      background: rgba(234, 67, 53, 0.2);
    }
  }

  .btnns1 {
    height: 38px;
    width: 38px;
    color: #49982d;
    border: 1px solid rgba(86, 185, 50, 0.4);
    border-radius: 8px;
    background: rgba(86, 185, 50, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .profile2 .accountDetailBoxTransparrent {
    border: 1px dashed rgba(255, 255, 255, 0.15);
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
      color: #888;
    }
  }

  .profile2 .accountDetailBoxTransparrent.blurrr {
    filter: blur(1px);
    cursor: not-allowed;

    button {
      cursor: not-allowed !important;
    }
  }

  .btnns3 {
    background: #007afe;
    color: white;
    padding: 8px 18px;
    border-radius: 8px;
    border: 0px;
    margin-top: 10px;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 122, 254, 0.2);

    &:hover {
      background: #0056cc;
      box-shadow: 0 4px 12px rgba(0, 122, 254, 0.3);
    }
  }

  .spanner3 {
    color: white;
    text-transform: uppercase;
  }

  .images2 {
    width: 100%;
    padding: 0px 2px 2px 2px;
  }

  /* ==================== BILLING TAB ==================== */
  .divider21 {
    width: 100%;
  }

  .divider22 {
    background: #181e27;
    border-radius: 10px;
    width: 100%;
    color: white;
    padding: 20px;
    margin-top: 16px;
    border: 1px solid rgba(255, 255, 255, 0.06);
  }

  .htp5 {
    font-family: 'Poppins', sans-serif;
    padding: 0px 0px 6px;
    margin-left: 0px;
    font-size: 15px;
    color: #ffffff;
    font-weight: 600;
  }

  .btnss1 {
    background: #007afe;
    color: #fff;
    padding: 8px 18px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 122, 254, 0.2);

    &:hover {
      background: #0056cc;
      box-shadow: 0 4px 12px rgba(0, 122, 254, 0.3);
    }
  }

  .row-space {
    display: flex;
    justify-content: space-between;
  }

  .row {
    display: flex;
    justify-content: center;
  }

  .row-space-profile {
    flex-direction: row;
  }

  .spaning {
    display: flex;
    align-items: center;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0.02em;
    color: #b8b8b8;

    svg {
      margin-right: 12px;
    }

    .paymentType {
      font-family: 'Poppins', sans-serif;
      font-size: 11px;
      font-weight: 500;
      padding: 4px 10px;
      background: rgba(0, 122, 254, 0.15);
      border: 1px solid rgba(0, 122, 254, 0.3);
      border-radius: 6px;
      margin-left: 16px;
      color: #007afe;
    }
  }

  .spaning1 {
    margin-left: 8px;
    color: #ffffff;
  }

  .spanning {
    color: #ffffff;
    margin-left: 0px;
  }

  .spanning1 {
    color: #ffffff;
    margin-left: 0px;
  }

  .BillingInfoFontSize {
    font-size: inherit;
    color: #ffffff;
  }

  /* ==================== PLAN SECTION ==================== */
  .planMainDiv {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
  }

  .planDiv {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 560px;
    background: #181e27;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.06);
  }

  .planDiv .planName {
    padding: 14px 18px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1c232e;
  }

  .planDiv .planName .name {
    background: #007afe;
    border: none;
    padding: 6px 16px;
    font-family: 'Poppins', sans-serif !important;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-align: center;
    border-radius: 6px;
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 122, 254, 0.2);
  }

  .planDiv .planName img {
    width: 36px;
  }

  .planDiv .planDetail {
    width: 100%;
    background: #181e27;
    padding: 22px;
  }

  .planDiv .planDetail h2 {
    font-family: 'Poppins', sans-serif !important;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    text-align: left;
    color: #ffffff;
    margin-bottom: 12px;
  }

  .planDiv .planDetail .perMonth {
    font-family: 'Poppins', sans-serif !important;
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    color: #b8b8b8;
  }

  .planDiv .planDetail .includes {
    margin-top: 20px;
  }

  .planDiv .includeHeading {
    font-family: 'Poppins', sans-serif !important;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.02em;
    text-align: left;
    margin-bottom: 14px;
    color: #888;
  }

  .planDiv .includesDiv {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .planDiv .includeDetail {
    width: 50%;
    font-family: 'Poppins', sans-serif;
    font-size: 11px;
    font-weight: 400;
    text-align: left;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #ffffff;
  }

  .planDiv .includeDetail svg {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }

  .planExpireDate {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-width: 260px;
  }

  .innerPlanExpireDate {
    width: 100%;
    max-width: 340px;
    background: #181e27;
    border-radius: 10px;
    padding: 22px;
    border: 1px solid rgba(255, 255, 255, 0.06);
  }

  .planExpireDate p {
    font-family: 'Poppins', sans-serif !important;
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    margin-bottom: 6px;
    color: #888;
  }

  .planExpireDate h1 {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.01em;
    text-align: left;
    color: white;
  }

  .planExpireDate hr {
    margin: 16px 0px;
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  .expireButtons {
    display: flex;
    flex-direction: column;
    gap: 10px;

    button {
      cursor: pointer;
    }
  }

  .expireButtons .upgradePlans {
    background: #007afe;
    color: white;
    height: 40px;
    width: 100%;
    border-radius: 8px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 122, 254, 0.2);

    &:hover {
      background: #0056cc;
      box-shadow: 0 4px 12px rgba(0, 122, 254, 0.3);
    }
  }

  .expireButtons .upgradePlans svg {
    margin-right: 8px;
  }

  .expireButtons .CancelPlans {
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.04);
    color: white;
    height: 40px;
    width: 100%;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;

    svg {
      margin-right: 8px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.2);
    }
  }

  /* ==================== TABLE STYLING ==================== */
  .invoice-history-table {
    .ant-table-wrapper {
      background: transparent !important;
    }
  }

  .ant-table-thead {
    display: none;
  }

  .ant-table-tbody,
  .ant-table-cell {
    background: #181e27 !important;
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
  }

  .ant-table-cell-row-hover {
    background: rgba(0, 122, 254, 0.1) !important;
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .ant-table-wrapper:after,
  .ant-table-wrapper:before {
    display: none;
  }

  .ant-table-tbody > tr.ant-table-placeholder:hover > td {
    background: #181e27 !important;
    color: #ffffff !important;
  }

  .ant-empty-description {
    color: #b8b8b8 !important;
  }

  .ant-modal-close {
    color: #ffffff !important;
  }

  .ant-table-cell-row-hover,
  .ant-table-cell-row-hover .moreOutline {
    color: white;
  }

  .InvoiceHistory {
    margin-left: 0%;
  }

  /* ==================== MISC ==================== */
  .spanner {
    font-size: 14px;
  }

  .spanner23 {
    background: rgba(0, 122, 255, 0.15);
    color: #007aff;
    border: 1px solid rgba(0, 122, 255, 0.3);
    border-radius: 6px;
    padding: 5px 12px;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 500;
  }

  .diver3 {
    background: #181e27;
    border-radius: 14px;
    width: calc(50% - 12px);
    color: white;
    display: flex;
    margin-top: 20px;
    align-items: center;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.08);
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(0, 122, 254, 0.3);
    }
  }

  .diver6 {
    width: 58%;
    margin-left: 3%;
  }

  .divers1 {
    border-radius: 14px;
    width: 48%;
    height: 140px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;
    border: 2px dashed rgba(255, 255, 255, 0.15);
    gap: 10px;
    margin-top: 20px;
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(0, 122, 254, 0.4);
    }
  }

  .divider24 {
    background: #181e27;
    border-radius: 14px;
    width: 100%;
    color: #ffffff;
    padding: 20px 28px;
    margin-top: 20px;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  .per-month {
    margin-left: 5px;
    font-size: 13px;
    color: #b8b8b8;
  }

  .general-section {
    display: grid;
    grid-template-columns: 1fr 0.5fr;
  }

  .input-wrapper {
    display: grid;
    gap: 20px;
    padding-top: 30px;
  }

  .paid {
    width: 80px;
  }

  /* ==================== RESPONSIVE STYLES ==================== */
  @media screen and (max-width: 1200px) {
    .profile {
      width: 260px;
      min-width: 260px;
    }

    .div {
      width: 115px;
      height: 100px;
    }
  }

  @media screen and (max-width: 900px) {
    .ant-tabs-tabpane:not(.ant-tabs-tabpane-hidden) {
      flex-direction: column;
    }

    .row-space-profile {
      flex-direction: column !important;
      width: 100%;
    }

    .profile,
    .profile1 {
      width: 100%;
      min-width: unset;
    }

    .profile {
      padding-bottom: 90px;
    }

    .logoutButton {
      position: relative;
      bottom: 0;
      padding: 20px;
    }

    .GeneralInformationFormStyleclassName {
      padding: 16px 0px 0px 0px;
      margin-bottom: 80px;
    }

    .rowing {
      justify-content: space-between;
    }

    .div {
      width: calc(50% - 6px);
      height: 100px;
    }

    .rowing2 {
      flex-wrap: wrap;
    }

    .rowing2 .div {
      width: calc(50% - 6px);
    }

    .profile2 .accountDetailBox {
      width: 100%;
    }

    .planMainDiv {
      flex-direction: column;
    }

    .planDiv {
      max-width: 100%;
    }

    .planExpireDate {
      width: 100%;
    }

    .innerPlanExpireDate {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 600px) {
    .ho2 {
      font-size: 20px;
    }

    .h2,
    .hoo2 {
      font-size: 15px;
    }

    .div {
      width: 100%;
    }

    .rowing2 .div {
      width: 100%;
    }

    .planDiv .includeDetail {
      width: 100%;
    }

    .profile2 {
      padding: 16px;
    }

    .planDiv .planDetail {
      padding: 16px;
    }

    .expireButtons .upgradePlans,
    .expireButtons .CancelPlans {
      width: 100%;
    }

    .ant-tabs-tab {
      padding: 10px 14px;
      font-size: 12px;
    }

    .ant-table-cell {
      font-size: 11px;
      padding: 8px !important;
    }
  }

  @media only screen and (min-width: 1400px) {
    .div {
      width: 145px;
      height: 115px;
    }
  }

  @media only screen and (min-width: 1600px) {
    .div {
      width: 155px;
      height: 120px;
    }
  }
`;

export { GeneralInformationFormStyle };
